import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment-timezone';
import { PgTitleComponent } from '../../shared/components/title-bar/title-bar.component';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { OrganisationServiceSpa } from 'src/app/generated/services/organisations/organisationSpa';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { MaterialPgIconButtonComponent } from 'src/app/shared/components/material-pg-iconbutton/material-pg-icon-button.component';

@Component({
  selector: 'app-new-organisation',
  templateUrl: './new-organisation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialAutoCompleteComponent,
    MatSelectModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDividerModule,
    MatIconModule,
    MaterialPgInputComponent,
    MaterialPgButtonComponent,
    MaterialPgIconButtonComponent,
  ]
})

export class NewOrganisationComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  newOrganisation: Organisation = Organisation.create();
  internalName = '';
  parentOrganisations!: Organisation[];
  edit!: boolean;
  showMessage!: boolean;
  message!: string;
  success!: boolean;
  // objectKeys = Object.keys;

  objectKeys = (obj: object) =>
    Object.keys(obj) as (keyof typeof this.availableProperties)[];

  availableTimeZones: string[] = [];
  showAdditionalData!: boolean;
  showAvailableProp!: boolean;

  addData!: string;
  addProp!: string;

  availableProperties = {
    isBuyer: 'خریدار',
    isSeller: 'فروشنده',
    isTransporter: 'حمل کننده',
    isUnloading: 'قابل تخلیه',
    isLoading: 'قابل بارگیری',
    isPort: 'Port',
    isShipper: 'Shipper',
    isConsignee: ' Consignee',
    isShippingAgent: 'Shipping Agent',
    isNotifying: 'Notifying',
    isAnchorage: 'Anchorege',
    isSurvey:'Surveor',
    isBunkerSupplier: 'Bunker Supplier',
    isFreshWaterSupplier: 'Fresh Water Supplier',
    isOilSupplier: 'Oil Supplier',
    isCharterer: 'Charterer',
    domestic : 'فعالیت درون کشوری',
    international: 'فعالیت بین المللی',
    correspondent: 'Correspondent',
    office: 'Office',
    airport: 'Airport',
    country: 'Country',
    owner: 'Ship Owner',
    commercial: 'Ship Commercial',
    technical: 'Ship Technical',
    allowEnteryFromUI:'Allow Entery From UI',
    vesselManager: 'Vessel Manager',
    vesselBuilder: 'Vessel Builder',
    vesselProtector: 'Vessel Protection and Indemnity'
  };

  additionalProp = {
    emailAddress: 'Email address',
    emailDomain: 'Email Domain',
    emailEndpoint: 'Email endpoint',
    webAddress: 'Web site'
  };

  propertyDic: {
    [key: string]: boolean;
  } = { };

  additionalPropDic: {
    [key: string]: string;
  } = { };

  constructor(private _organisationsService: OrganisationServiceSpa,
              private _activatedRoute: ActivatedRoute,
              private _pgMessagesService: PgMessagesService) {
  }

  ngOnInit() {
    this.title.emit('Organisation');
    this.availableTimeZones = moment.tz.names();
    this.getCurrentOrganisation();
  }

  getCurrentOrganisation() {
    this._activatedRoute.paramMap.subscribe(p => {
      this.edit = (p.get('mode') === 'edit') ? true : false;
      const organisationId = p.get('organisationId');
      this._organisationsService.getAllOrganisations({})
        .then(result => {
          this.parentOrganisations = result.organisations;
          if (!this.edit) {
            if (organisationId === 'root') {
              this.initialOrganisation('');
            } else {
              this.initialOrganisation(organisationId ?? '');
            }
          }
          if (this.edit) {
            this.newOrganisation = result.organisations.find(o => o.name === organisationId) || Organisation.create();
            const name = this.newOrganisation.name.split('.');
            this.internalName = name[name.length - 1];
            if (this.newOrganisation.properties) {
              this.propertyDic = this.newOrganisation.properties;
              for (const p in this.availableProperties) {
                if (!this.propertyDic[p]) {
                  delete this.propertyDic[p];
                }
              }
            }
            if (this.newOrganisation.additionalData) {
              this.additionalPropDic = this.newOrganisation.additionalData;
            }
          }
        });
    });
  }

  addAvailableProp(event: string | number) {
    const key = String(event);

    if (!(key in this.propertyDic)) {
      this.propertyDic[key] = false;
    }

    this.showAvailableProp = false;
  }

  addExtendedProp(event: string | number) {
    console.log(event);
    const key = String(event);

    if (!this.additionalPropDic[key]) {
      this.additionalPropDic[key] = '';
    }

    this.showAdditionalData = false;
    this.addData = '';
  }

  removeAdditionalProp(key: string) {
    delete this.additionalPropDic[key];
  }

  showAdditionalProp() {
    this.showAdditionalData = true;
  }

  showAvailables() {
    this.showAvailableProp = true;
  }

  add() {
    if (!this.internalName.startsWith(this.newOrganisation.parentOrganisation || '')) {
      this.newOrganisation.name =
        `${this.newOrganisation.parentOrganisation}.${this.internalName}`;
    } else  {
      this.newOrganisation.name = this.internalName;
    }

    this.newOrganisation.properties = this.propertyDic;
    this.newOrganisation.additionalData = this.additionalPropDic;
    if (!this.edit) {
      this._organisationsService.updateOrganisation(this.newOrganisation)
        .then(() => {
          this._pgMessagesService.publishMessage({
            message:  `${this.newOrganisation.nameTranslations['en']} Imported`,
            topic: 'New Organisation',
            level: MessageLevel.Info
          });
        });
    } else if (this.edit) {
      this._organisationsService.updateOrganisation(this.newOrganisation).then(() => {
        this._pgMessagesService.publishMessage({
          message: ` ${this.newOrganisation.nameTranslations['en']} Updated`,
          topic: 'Organisation',
          level: MessageLevel.Info
        });
      });
    }
  }
  formatter = (key: string) => {
    return this.additionalProp[key as keyof typeof this.additionalProp] ?? key;
  };

  initialOrganisation(parentId: string) {
    const parent = (this.parentOrganisations.find(o => o.name === parentId));
    this.newOrganisation = {
      name: '',
      address: '',
      manager: '',
      parentOrganisation: parentId,
      nameTranslations: {
        fa: ''
      },
      properties: {},
      location: {
        longitude: 0,
        latitude: 0
      },
      timezone: parent && parent.timezone ? parent.timezone : '',
      additionalData: {}
    };
  }

  availablePropFormatter = (key: string) => {
    return this.availableProperties[key as keyof typeof this.availableProperties] ?? key;
  };

}
